export default {
  RECURRENCE_RULE_SECTION: `Récurrence`,
  frequency: {
    DAILY: `Chaque jour`,
    WEEKLY: `Chaque semaine`,
    NONE: `Aucune`
  },
  ends: {
    UNTIL: `À une date`,
    COUNT: `Après un certain nombre de quarts`
  },
  form: {
    FREQUENCY: {
      LABEL: `Fréquence`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    INTERVAL: {
      LABEL: `Intervalle`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    ENDS: {
      LABEL: `Finit`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    COUNT: {
      LABEL: `Nombre de répétitions`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``,
      NUMBER_OCCURENCES: 'fois'
    },
    UNTIL: {
      LABEL: `Date de fin`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    DAILY: `jours`,
    WEEKLY: `semaines`,
    MONDAY: { LABEL: `Lun` },
    TUESDAY: { LABEL: `Mar` },
    WEDNESDAY: { LABEL: `Mer` },
    THURSDAY: { LABEL: `Jeu` },
    FRIDAY: { LABEL: `Ven` },
    SATURDAY: { LABEL: `Sam` },
    SUNDAY: { LABEL: `Dim` }
  },
  toText: {
    EVERY: `Tous les`,
    DAY: `jours`,
    DAYS: `jours`,
    WEEK: `semaines`,
    WEEKS: `semaines`,
    WEEKDAY: `jours de semaine`,
    UNTIL: `jusqu'au`,
    ON: `le`,
    FOR: `pour`,
    TIME: `fois`,
    TIMES: `fois`
  }
}
